import React from 'react';
import { Section } from './ui/Section';
import { MapPin, Clock, Phone, Mail } from 'lucide-react';
export function LocationSection() {
  return <Section background="gray" data-id="element-74">
      <div className="grid md:grid-cols-2 gap-12" data-id="element-75">
        {/* Info */}
        <div data-id="element-76">
          <h2 className="text-3xl font-black text-gray-900 mb-8" data-id="element-77">Visit Us</h2>

          <div className="space-y-8" data-id="element-78">
            <div className="flex items-start gap-4" data-id="element-79">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm text-red-600 flex-shrink-0" data-id="element-80">
                <MapPin className="w-5 h-5" data-id="element-81" />
              </div>
              <div data-id="element-82">
                <h3 className="font-bold text-gray-900 mb-1" data-id="element-83">Location</h3>
                <p className="text-gray-600" data-id="element-84">
                  123 Main Street
                  <br data-id="element-85" />
                  Springfield, IL 62704
                </p>
                <p className="text-sm text-gray-500 mt-2" data-id="element-86">
                  Proudly serving Springfield, Chatham, and Rochester.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-87">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm text-red-600 flex-shrink-0" data-id="element-88">
                <Clock className="w-5 h-5" data-id="element-89" />
              </div>
              <div data-id="element-90">
                <h3 className="font-bold text-gray-900 mb-1" data-id="element-91">Class Hours</h3>
                <p className="text-gray-600" data-id="element-92">
                  Mon - Fri: 3:30 PM - 8:30 PM
                  <br data-id="element-93" />
                  Sat: 9:00 AM - 1:00 PM
                  <br data-id="element-94" />
                  Sun: Closed
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-95">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm text-red-600 flex-shrink-0" data-id="element-96">
                <Phone className="w-5 h-5" data-id="element-97" />
              </div>
              <div data-id="element-98">
                <h3 className="font-bold text-gray-900 mb-1" data-id="element-99">Contact</h3>
                <p className="text-gray-600" data-id="element-100">
                  <a href="tel:555-928-7661" className="hover:text-red-600 transition-colors" data-id="element-101">
                    (555) WATSON-1
                  </a>
                </p>
                <p className="text-gray-600" data-id="element-102">
                  <a href="mailto:info@watsonmartialarts.com" className="hover:text-red-600 transition-colors" data-id="element-103">
                    info@watsonmartialarts.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Map Placeholder */}
        <div className="h-[400px] bg-gray-200 rounded-2xl overflow-hidden shadow-inner relative group" data-id="element-104">
          <div className="absolute inset-0 flex items-center justify-center bg-gray-300 text-gray-500 font-mono uppercase tracking-widest" data-id="element-105">
            [Google Maps Embed]
          </div>
          <div className="absolute bottom-4 left-4 bg-white px-4 py-2 rounded shadow-md text-xs font-bold text-gray-700" data-id="element-106">
            Watson Martial Arts
          </div>
        </div>
      </div>
    </Section>;
}